import { GridAlignment } from "@mui/x-data-grid-pro";

export const TEXT_FONT_FAMILY = "Josefin Sans ";
export const HEADER_TEXT_ALIGN: GridAlignment = "center";
export const SLNO_TEXT_ALIGN: GridAlignment = "center";
export const MARKS_TEXT_ALIGN: GridAlignment = "center";

export const AMOUNT_TEXT_ALIGN: GridAlignment = "right";
export const NUMBER_FONT_FAMILY = "Spline Sans Mono";
export const TABLE_ROW_HEIGHT = 30;

export const TABLE_FONT_SIZE = 14;
export const enum TOOLTIP_COLORS {
  GREY = "#78716c",
  TEAL = "#4fd1c5",
  VARIABLE = "var(--level-5)",
  SKY = "#38bdf8",
  PURPLE = "#c084fc",
  PINK = "#f472b6",
  LIME = "#a3e635",
  GREEN = "#22c55e",
  FUCHSIA = "#e879f9",
  BLUE = "#3b82f6",
  AMBER = "#fcd34d"
}
export const enum FlexForColumns {
  SLNO = 0.2,
  MOBILE_NO = 0.5,
  CONTACT_PERSON = 0.5,
  ADDRESS = 0.5,
  ACTION = 0.4,
  ACTION_BUTTON = 0.5,
  DESCRIPTION = 1,
  EMAIL = 0.5,
  AMOUNT = 0.5,
  CODE=0.4,
  PERCENTAGE=0.4,
  SUB_DESC=0.4,
  GST_N0=0.5,
  CITY=0.4,
  STATE=0.4,
  NUMBER=0.3,
  DATE=0.3,
  STATUS=0.3,
  NAME = 2,
}
